export const ALIGN_START = 'start';
export const ALIGN_CENTER = 'center';
export const ALIGN_END = 'end';
export const ALIGN_AROUND = 'around';
export const ALIGN_BASELINE = 'baseline';
export const ALIGN_STRETCH = 'stretch';
